import script from "./placeAttributes.vue?vue&type=script&setup=true&lang=js"
export * from "./placeAttributes.vue?vue&type=script&setup=true&lang=js"

import "./placeAttributes.vue?vue&type=style&index=0&id=4767e717&scoped=true&lang=scss"

import exportComponent from "/home/steffen/Projekte/clubadmin/frontend/homepage/gc-schoenbuch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4767e717"]])

export default __exports__